import React, { useMemo } from 'react'

import { Text } from '@interco/inter-ui/components/Text'
import { Spacing } from '@interco/inter-ui/components/Spacing'
import { Button } from '@interco/inter-ui/components/Button'

import * as S from './styles'

interface IProgressBarWithDetailsProps {
  title?: string
  subtitle?: string
  leftTitle: string
  leftValue: string
  rightTitle: string
  rightValue: string
  progressPercentage: string
  onBtnChangeLimit?: () => void
  onClickTitleAction?: () => void
}

export const ProgressBarWithDetails = ({
  title,
  subtitle,
  leftTitle,
  leftValue,
  rightTitle,
  rightValue,
  progressPercentage,
  onBtnChangeLimit,
  onClickTitleAction,
}: IProgressBarWithDetailsProps) => {
  const isTotalLimitUsed = useMemo(() => progressPercentage === '100%', [progressPercentage])

  const getBgColorLimitUsage = () => {
    const temp = parseFloat(progressPercentage.replace('%', ''))

    if (temp < 40) {
      return 'var(--alert500)'
    }
    return 'var(--error500)'
  }

  return (
    <S.Container>
      {title && (
        <>
          <S.ContainerInfo>
            <Text variant="headline-h3" semiBold colorWeight={500}>
              {title}
            </Text>
            {subtitle && (
              <Text variant="caption-1" bold color="primary" onClick={onClickTitleAction}>
                {subtitle}
              </Text>
            )}
          </S.ContainerInfo>
          <Spacing mb="xs" />
        </>
      )}

      <S.LimitProgress bgColor={getBgColorLimitUsage()} percentage={progressPercentage} />

      <Spacing mb="xs" />

      <S.ContainerInfo>
        <S.Info>
          <Text variant="caption-1" bold colorWeight={isTotalLimitUsed ? 300 : 500}>
            {leftValue}
          </Text>
          <Spacing mb="xxs" />
          <Text variant="caption-1" bold colorWeight={isTotalLimitUsed ? 300 : 500}>
            {leftTitle}
          </Text>
        </S.Info>

        <S.Info alignToEnd>
          <Text variant="caption-1" bold colorWeight={isTotalLimitUsed ? 300 : 500}>
            {rightValue}
          </Text>
          <Spacing mb="xxs" />
          <Text variant="caption-1" bold colorWeight={isTotalLimitUsed ? 300 : 500}>
            {rightTitle}
          </Text>
        </S.Info>
      </S.ContainerInfo>

      <Spacing mb="xxs" />
      {onBtnChangeLimit && (
        <>
          <Spacing mb="xs" />
          <Button variant="secondary" size="small" onClick={onBtnChangeLimit}>
            Alterar limite
          </Button>
        </>
      )}
    </S.Container>
  )
}
